export default "__VITE_ASSET__fIz0i7y$__"